module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-antiderrapante.b41716f1.jpg";